
import Vue from 'vue'

import Global from './global'
import auth from './auth'
import { Api } from './api'

export default {

    connection: null,

    connect() {

        var _user = auth.currentUser();
        if (_user) {

            this.connection.start().then(() => {

                this.connection.invoke("Setar", _user.pessoaCNAId);

                this.connection.on("Atualizado", atualizado => {
                    if (atualizado) {
                        auth.updatePessoaCna(_user.pessoaCNAId, (pessoaCNA) => {

                            new Api("pessoa/verificapessoaexistente").post(pessoaCNA).then(result => {
                                console.log("awuyuiuuuuuuuuuuu")
                            })

                            Vue.prototype.$eventHub.$emit('user-atualizado')
                        })
                    }
                });

            }, () => {
                setTimeout(() => {
                    this.connect()
                }, 5000);
            });
        }

        this.connection.onclose(() => {
            this.connect();
        });

    },

    start() {

        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(Global.END_POINT_SIGNALR + "/pessoacna-hub")
            .build();

        setTimeout(() => {
            this.connect();
        }, 5000);
    }

}